module.exports = __webpack_public_path__ + "img/PL09055.70877c7c.png";